import { isObject } from '@repo/utils/type.utils';

export interface GetBarCodeResponse {
    barCode: string;
}

export function isGetBarCodeResponse(value: unknown): value is GetBarCodeResponse {
    return isObject(value) && 'barCode' in value;
}
